import React, { useContext } from 'react'
import { RemoteComponent } from '@contrast-security-inc/design-system-foundations'
import { RouteContext } from '../route-provider'

const RemoteAttackEventsPage = React.lazy(
  // @ts-ignore
  () => import('attackEvents/AttackEventsPage')
)

export const AttackEventsPage = () => {
  const { organizationID } = useContext(RouteContext)

  return (
    <RemoteComponent>
      <RemoteAttackEventsPage basename={`/${organizationID}/attack-events`} />
    </RemoteComponent>
  )
}
